import FileSaver from 'file-saver';
import JSZip from 'jszip';

export async function downloadZip(
  files: { blob: Blob; name: string }[],
  zipName: string,
): Promise<void> {
  const zip = new JSZip();

  files.map((file) => {
    zip.file(file.name, file.blob);
  });

  const zippedFile = await zip.generateAsync({ type: 'blob' });

  FileSaver.saveAs(zippedFile, `${zipName}.zip`);
}
